/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface KtlCodeOverrideInterface {
  "timeframeId": string;
  "taskId": string;
  "ktlCode": string;
  "author"?: string;
  "created"?: Date;
  "id"?: any;
  "patientId"?: any;
  patient?: Patient;
}

export class KtlCodeOverride implements KtlCodeOverrideInterface {
  "timeframeId": string;
  "taskId": string;
  "ktlCode": string;
  "author": string;
  "created": Date;
  "id": any;
  "patientId": any;
  patient: Patient;
  constructor(data?: KtlCodeOverrideInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `KtlCodeOverride`.
   */
  public static getModelName() {
    return "KtlCodeOverride";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of KtlCodeOverride for dynamic purposes.
  **/
  public static factory(data: KtlCodeOverrideInterface): KtlCodeOverride{
    return new KtlCodeOverride(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'KtlCodeOverride',
      plural: 'KtlCodeOverrides',
      path: 'KtlCodeOverrides',
      idName: 'id',
      properties: {
        "timeframeId": {
          name: 'timeframeId',
          type: 'string'
        },
        "taskId": {
          name: 'taskId',
          type: 'string'
        },
        "ktlCode": {
          name: 'ktlCode',
          type: 'string'
        },
        "author": {
          name: 'author',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
